// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import AppModal from '../components/AppModal';
import { useI18n } from '../context/I18nContext';

const ROLES = ['sales', 'finance', 'customer'];

export default function Permissions() {
    const { t, lang } = useI18n();
    const [permissions, setPermissions] = useState([]);
    const [matrix, setMatrix] = useState({});
    const [selectedRole, setSelectedRole] = useState('sales');
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState('');

    const tl = (obj, field) => {
        if (!obj) return '';
        if (lang === 'fr') return obj[`${field}_fr`] || obj[field];
        if (lang === 'ar') return obj[`${field}_ar`] || obj[field];
        return obj[field];
    };

    const load = () => {
        setLoading(true);
        api.get('/permissions')
            .then((res) => {
                setPermissions(res.data.data.permissions);
                setMatrix(res.data.data.matrix);
                setSelected(res.data.data.matrix[selectedRole] || []);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    useEffect(() => {
        setSelected(matrix[selectedRole] || []);
    }, [selectedRole, matrix]);

    const toggle = (id) => {
        setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
    };

    const save = async () => {
        setSaving(true);
        setMsg('');
        try {
            await api.put('/permissions/role', { role: selectedRole, permission_ids: selected });
            setMsg('Permissions saved successfully');
            load();
        } catch (err) {
            setMsg(err.response?.data?.message || 'Failed');
        } finally {
            setSaving(false);
        }
    };

    const modules = [...new Set(permissions.map((p) => p.module))];

    return (
        <div>
            <div className="mb-4">
                <h4 className="mb-1">Role Permissions</h4>
                <p className="text-muted mb-0">Admin can configure module access per role (Sales, Finance, Customer). Admin always has full access.</p>
            </div>

            {msg && <div className="alert alert-info py-2">{msg}</div>}

            <div className="d-flex gap-2 mb-3 flex-wrap">
                {ROLES.map((r) => (
                    <button
                        key={r}
                        type="button"
                        className={`btn btn-sm text-capitalize ${selectedRole === r ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => setSelectedRole(r)}
                    >
                        {r}
                    </button>
                ))}
                <button className="btn btn-success btn-sm ms-auto" onClick={save} disabled={saving}>
                    {saving ? 'Saving…' : t('save')}
                </button>
            </div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-success" /></div>
            ) : (
                <div className="row g-3">
                    {modules.map((mod) => (
                        <div className="col-md-6 col-xl-4" key={mod}>
                            <div className="card table-card h-100">
                                <div className="card-header fw-semibold text-capitalize">{mod}</div>
                                <div className="card-body py-2">
                                    {permissions.filter((p) => p.module === mod).map((p) => (
                                        <div className="form-check" key={p.id}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`perm-${p.id}`}
                                                checked={selected.includes(p.id)}
                                                onChange={() => toggle(p.id)}
                                            />
                                            <label className="form-check-label" htmlFor={`perm-${p.id}`}>
                                                {tl(p, 'label')}
                                                <small className="text-muted d-block">{p.key}</small>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}